module.exports = __webpack_public_path__ + "img/2.31e65940.png";